import script from "./BombasSemillasView.vue?vue&type=script&setup=true&lang=js"
export * from "./BombasSemillasView.vue?vue&type=script&setup=true&lang=js"

import "./BombasSemillasView.vue?vue&type=style&index=0&id=2172bab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2172bab8"]])

export default __exports__